<script>
 export let tabs;
 export let activeTab;
 import { createEventDispatcher } from 'svelte';
 const dispatch = createEventDispatcher();

</script>

<style>
    .tabs{
        background-color: transparent;     
    }
    .tabText{
        background-color: transparent;
        
        
    }
    ul{
        display: flex;
        float: left;
        padding: 0;
        list-style-type: none;
        background-color: transparent;
        height: 100%;
        margin: 0;
    }
    li{
        margin: 0px 16px;
        color: grey;
        cursor: pointer;
        height: 100%;
        display:flex;
        justify-content: center;
        align-items: center;
    }
    li:hover{
        color: black;
        font-weight: bold;
    }
    .active{        
        margin: auto;       
        
    }
</style>

<div class="tabs">
    <ul>
        {#each tabs as tab}
            <li on:click={()=> dispatch('tabChange', tab)}>
                {#if tab === activeTab}
                <div class="tabText font-weight-bold text-primary active">{tab}</div>
                {:else}
                <div class="tabText">{tab}</div>
                {/if}
                
            </li>
        {/each}
    </ul>
</div>